"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("apps/dashboard");
require("apps/trips");
exports.default = angular.module('profumo.apps', [
    'profumo.apps.dashboard',
    'profumo.apps.trips'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/index.ts
// module id = 469
// module chunks = 0